<template>
  <div class="loader-container show">
    <svg id="loader-svg" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 80 60" preserveAspectRatio="none">
      <path d="m -5,-5 0,70 90,0 0,-70 z m 5,5 c 0,0 7.9843788,0 40,0 35,0 40,0 40,0 l 0,60 c 0,0 -3.944487,0 -40,0 -30,0 -40,0 -40,0 z" />
    </svg>
  </div>
</template>

<script>
import Snap from "snapsvg-cjs";

export default {
  name: "SvgLoader",
  data() {
    return {
      openingSteps: "",
      closingSteps: "",
      openingStepsTotal: "",
      closingStepsTotal: "",
      path: "",
      initialPath: "m -5,-5 0,70 90,0 0,-70 z m 5,5 c 0,0 7.9843788,0 40,0 35,0 40,0 40,0 l 0,60 c 0,0 -3.944487,0 -40,0 -30,0 -40,0 -40,0 z"
    };
  },
  mounted() {
    const that = this;
    var s = Snap(document.getElementById("loader-svg"));
    this.path = s.select("path");
    this.initialPath = this.path.attr("d");
    let openingStepsStr =
      "m -5,-5 0,70 90,0 0,-70 z m 5,35 c 0,0 15,20 40,0 25,-20 40,0 40,0 l 0,0 C 80,30 65,10 40,30 15,50 0,30 0,30 z";
    this.openingSteps = openingStepsStr ? openingStepsStr.split(";") : "";
    this.openingStepsTotal = openingStepsStr ? this.openingSteps.length : 0;

    let closingStepsStr = this.initialPath;
		this.closingSteps = closingStepsStr ? closingStepsStr.split(';') : '';
		this.closingStepsTotal = closingStepsStr ? this.closingSteps.length : 0;



    this.nextStepShow(0);
    setTimeout(() => {
      that.nextStepHide(0);
    }, 1000);
    //
  },
  methods: {
    nextStepShow: function() {
      this.path.animate(
        { path: this.openingSteps[0] },
        500,
        mina.linear,
        function() {
        }
      );
    },
    nextStepHide: function() {
      this.path.animate(
        { path: this.closingSteps[0] },
        500,
        mina.linear,
        function() {
        }
      );
    }
  }
};
</script>
<style lang="scss" scoped>
.loader-container {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  visibility: hidden;
  z-index: 1000;
  &.show {
    visibility: visible;
  }
  svg {
    position: absolute;
    top: 0;
    left: 0;
    pointer-events: none;
    path {
      fill: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SvgLoader.vue